import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = "https://api.dilanaslan.com/api";

// Müşterinin paketlerini getir
export const fetchCustomerPackages = createAsyncThunk(
  "customerPackages/fetchCustomerPackages",
  async (customerId) => {
    const res = await axios.get(`${BASE_URL}/customer-packages/customer/${customerId}`);
    return res.data;
  }
);

// Müşteriye paket sat
export const createCustomerPackage = createAsyncThunk(
  "customerPackages/createCustomerPackage",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${BASE_URL}/customer-packages`, data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || "Paket atanamadı");
    }
  }
);

// Müşteri paketi güncelle
export const updateCustomerPackage = createAsyncThunk(
  "customerPackages/updateCustomerPackage",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${BASE_URL}/customer-packages/${id}`, data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || "Paket güncellenemedi");
    }
  }
);

// Ödeme durumu güncelle
export const updateCustomerPackagePayment = createAsyncThunk(
  "customerPackages/updateCustomerPackagePayment",
  async ({ id, isPaid, paymentDate, paymentMethod }, { rejectWithValue }) => {
    try {
      const res = await axios.patch(`${BASE_URL}/customer-packages/${id}/payment`, {
        isPaid, paymentDate, paymentMethod,
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || "Ödeme güncellenemedi");
    }
  }
);

// Müşteri paketi sil
export const deleteCustomerPackage = createAsyncThunk(
  "customerPackages/deleteCustomerPackage",
  async (id) => {
    await axios.delete(`${BASE_URL}/customer-packages/${id}`);
    return id;
  }
);

const customerPackageSlice = createSlice({
  name: "customerPackages",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => { state.error = null; },
    clearItems: (state) => { state.items = []; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerPackages.pending, (state) => { state.loading = true; })
      .addCase(fetchCustomerPackages.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchCustomerPackages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(createCustomerPackage.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(createCustomerPackage.fulfilled, (state, action) => {
        state.loading = false;
        state.items.unshift(action.payload);
      })
      .addCase(createCustomerPackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateCustomerPackage.fulfilled, (state, action) => {
        state.items = state.items.map((cp) =>
          cp._id === action.payload._id ? action.payload : cp
        );
      })

      .addCase(updateCustomerPackagePayment.fulfilled, (state, action) => {
        state.items = state.items.map((cp) =>
          cp._id === action.payload._id ? action.payload : cp
        );
      })

      .addCase(deleteCustomerPackage.fulfilled, (state, action) => {
        state.items = state.items.filter((cp) => cp._id !== action.payload);
      });
  },
});

export const { clearError, clearItems } = customerPackageSlice.actions;
export default customerPackageSlice.reducer;
